import { CommonMessage } from '@frontend/lang';
import { FormattedMessage } from 'react-intl';

import DefaultFooter from '../footer/default-footer.component';
import HomeHeader from '../header/home-header/home-header';
import useHomeFallback from './home-fallback.controller';

const ID = 'home-fallback';
export interface HomeFallbackProps {}

const HomeFallback = (props: HomeFallbackProps) => {
    const viewProps = useHomeFallback(props);

    return (
        <div
            id={ID}
            className='flex h-dvh flex-col'>
            <HomeHeader />
            <div className='bg-background-default relative h-full flex-col items-center pt-5 text-center'>
                <FormattedMessage
                    id='home-fallback.no-license-message'
                    defaultMessage='It seems you don’t have any licenses.'
                    description='Message displayed when there is no license available'
                />
                <div className='pointer-events-none absolute bottom-6 flex w-full flex-row items-center justify-center'>
                    <button
                        id='continue-button'
                        onClick={viewProps.refresh}
                        className='bg-brand-primary disabled:bg-brand-disabled pointer-events-auto inline-flex w-48 items-center justify-center rounded-xl px-4 py-3.5'>
                        <div className='text-background-surface justify-start text-base font-medium'>{CommonMessage.BUTTONS.REFRESH}</div>
                    </button>
                </div>
            </div>
            <DefaultFooter />
        </div>
    );
};

export default HomeFallback;
